// WOS-BUNDLE: row contracts of `tables/cell/work-bundle.ts` (tags, task tags, task links,
// favorites, recents, My Tasks sections and placements, the task timer). Same conventions as
// `work-rows.ts`; `contract-drift.test.ts` binds each to its table.
import { z } from "zod";
import { ActorShortColumns } from "./actor";
import { FavoriteKind, RecentKind, TagColor, TaskLinkKind } from "./enums";
import { Timestamp, Uuid } from "./primitives";

const actor = ActorShortColumns.shape;

export const Tag = z
  .object({
    company_id: Uuid,
    id: Uuid,
    name: z.string(),
    color: TagColor,
    ...actor,
    created_at: Timestamp,
    updated_at: Timestamp,
  })
  .meta({ id: "Tag" });
export type Tag = z.infer<typeof Tag>;

export const TaskTag = z
  .object({
    company_id: Uuid,
    task_id: Uuid,
    tag_id: Uuid,
    ...actor,
    created_at: Timestamp,
  })
  .meta({ id: "TaskTag" });
export type TaskTag = z.infer<typeof TaskTag>;

export const TaskLink = z
  .object({
    company_id: Uuid,
    task_id: Uuid,
    linked_task_id: Uuid,
    kind: TaskLinkKind,
    ...actor,
    created_at: Timestamp,
  })
  .meta({ id: "TaskLink" });
export type TaskLink = z.infer<typeof TaskLink>;

export const Favorite = z
  .object({
    company_id: Uuid,
    membership_id: Uuid,
    kind: FavoriteKind,
    object_id: Uuid,
    position: z.int(),
    created_at: Timestamp,
    updated_at: Timestamp,
  })
  .meta({ id: "Favorite" });
export type Favorite = z.infer<typeof Favorite>;

export const RecentItem = z
  .object({
    company_id: Uuid,
    membership_id: Uuid,
    kind: RecentKind,
    object_id: Uuid,
    viewed_at: Timestamp,
  })
  .meta({ id: "RecentItem" });
export type RecentItem = z.infer<typeof RecentItem>;

export const MyTaskSection = z
  .object({
    company_id: Uuid,
    id: Uuid,
    membership_id: Uuid,
    name: z.string(),
    position: z.int(),
    created_at: Timestamp,
    updated_at: Timestamp,
  })
  .meta({ id: "MyTaskSection" });
export type MyTaskSection = z.infer<typeof MyTaskSection>;

export const MyTaskPlacement = z
  .object({
    company_id: Uuid,
    membership_id: Uuid,
    task_id: Uuid,
    section: z.string(),
    position: z.int(),
    updated_at: Timestamp,
  })
  .meta({ id: "MyTaskPlacement" });
export type MyTaskPlacement = z.infer<typeof MyTaskPlacement>;

export const TaskTimer = z
  .object({
    company_id: Uuid,
    membership_id: Uuid,
    task_id: Uuid,
    seat_id: Uuid,
    started_at: Timestamp,
    note: z.string().nullable(),
    created_at: Timestamp,
  })
  .meta({ id: "TaskTimer" });
export type TaskTimer = z.infer<typeof TaskTimer>;
